import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedCounter } from '../ui/AnimatedCounter';
import { Heart, Leaf, Globe, Award } from 'lucide-react';
const metrics = [{
  id: 1,
  label: 'Mascotas Ayudadas',
  value: 50000,
  suffix: '+',
  icon: Heart,
  color: 'text-rose-500',
  bg: 'bg-rose-50',
  desc: 'Vidas transformadas con nutrición real'
}, {
  id: 2,
  label: 'Kg de Plástico Ahorrado',
  value: 12500,
  suffix: 'kg',
  icon: Leaf,
  color: 'text-emerald-500',
  bg: 'bg-emerald-50',
  desc: 'Envases 100% reciclables y sostenibles'
}, {
  id: 3,
  label: 'Donaciones a Refugios',
  value: 25000,
  suffix: '€',
  icon: Globe,
  color: 'text-blue-500',
  bg: 'bg-blue-50',
  desc: 'Apoyando a quienes más lo necesitan'
}, {
  id: 4,
  label: 'Veterinarios Asociados',
  value: 150,
  suffix: '+',
  icon: Award,
  color: 'text-purple-500',
  bg: 'bg-purple-50',
  desc: 'Avalado por la comunidad científica'
}];
export function ImpactMetrics() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-121">
      {metrics.map((metric, index) => <motion.div key={metric.id} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.1,
      duration: 0.6
    }} className="bg-white rounded-3xl p-8 border border-gray-100 shadow-soft-lg hover:shadow-soft-xl transition-shadow duration-300 relative overflow-hidden group" data-id="element-122">
          {/* Background Blob */}
          <div className={`absolute -right-4 -top-4 w-24 h-24 rounded-full ${metric.bg} opacity-50 group-hover:scale-150 transition-transform duration-500 ease-out`} data-id="element-123" />

          <div className="relative z-10" data-id="element-124">
            <div className={`w-12 h-12 rounded-2xl ${metric.bg} flex items-center justify-center mb-6`} data-id="element-125">
              <metric.icon className={`w-6 h-6 ${metric.color}`} data-id="element-126" />
            </div>

            <div className="text-4xl font-bold text-charcoal-900 font-serif mb-2 flex items-baseline" data-id="element-127">
              <AnimatedCounter value={metric.value} duration={2.5} data-id="element-128" />
              <span className="text-2xl ml-1" data-id="element-129">{metric.suffix}</span>
            </div>

            <h3 className="text-sm font-bold text-charcoal-500 uppercase tracking-wider mb-2" data-id="element-130">
              {metric.label}
            </h3>

            <p className="text-charcoal-600 text-sm leading-relaxed" data-id="element-131">
              {metric.desc}
            </p>
          </div>
        </motion.div>)}
    </div>;
}